/** Die Bereiche der Administration (Issue #31). Sidebar und Inhalt lesen dieselbe Liste. */
export interface AdminSection {
  id: string;
  name: string;
  hint: string;
}

export const ADMIN_SECTIONS: readonly AdminSection[] = [
  { id: "organisation", name: "Organisation", hint: "Name, Kennung und Status des Mandanten" },
  { id: "domains", name: "Domains", hint: "Eigene Domains nachweisen und verwalten" },
  { id: "email", name: "E-Mail", hint: "Aliasse, Verteiler und geteilte Postfächer" },
  { id: "members", name: "Benutzer", hint: "Einladen, bearbeiten, deaktivieren" },
  { id: "groups", name: "Gruppen", hint: "Teams und Verteiler" },
  { id: "roles", name: "Rollen und Rechte", hint: "Wer darf was im Mandanten" },
  { id: "security", name: "Sicherheit", hint: "Anmeldung, Zwei-Faktor, Sitzungen" },
];

export function findSection(id: string | null): AdminSection {
  return ADMIN_SECTIONS.find((section) => section.id === id) ?? (ADMIN_SECTIONS[0] as AdminSection);
}
